import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { UserGoalPageProps } from "./show.props";
import { Letterbooks } from "features/Letterbooks";
import DynamicListContainer from "features/tags/components/TagHeader/DynamicListContainer/DynamicListContainer";
import ProfileWrapper from "components/profile/ProfileWrapper";
import BookGoalGroup from "components/BookGroup/groups/BookGoalGroup";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import UpdateProgressButton from "features/goals/components/UpdateProgressButton";
import Button from "hardcover-ui/components/Button";

function GoalShowPage() {
  const { letterbooks, goal, view, user } = usePage<UserGoalPageProps>().props;
  const currentUserId = useCurrentUserId();
  const isOwner = user.id === currentUserId;

  return (
    <ProfileWrapper user={user}>
      <DynamicListContainer view={view}>
        <div className="mt-4 space-y-4">
          <div className="space-y-3 px-2">
            {isOwner && (
              <div className="flex flex-row gap-2 justify-end items-center">
                <UpdateProgressButton goal={goal} />
                <Button
                  variant="tertiary"
                  size="md"
                  as={{
                    element: "link",
                    props: {
                      href: `/@${user.username}/goals/${goal.id}/edit`,
                    },
                  }}
                >
                  Edit goal
                </Button>
              </div>
            )}
          </div>

          <BookGoalGroup goal={goal} user={user} size="lg" />
          
          <Letterbooks context={letterbooks} />
        </div>
      </DynamicListContainer>
    </ProfileWrapper>
  );
}

GoalShowPage.layout = DefaultLayoutWrapper;
export default GoalShowPage;